import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: 'Taran Arora | Web Developer', // e.g: 'Name | Developer'
  lang: 'en', // e.g: en, es, fr, jp
  description: 'Welcome to my web portfolio', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: 'Hi, my name is',
  name: 'Taran Arora',
  subtitle: 'I like to make stuff with code',
  cta: 'Know more',
};

// ABOUT DATA
export const aboutData = {
  img: 'profile.jpeg',
  paragraphOne: 'I am a Web Developer with enthusiasm and focus on Frontend Development',
  paragraphTwo:
    'I am passionate about building scalable software, creating effective solutions, and learning every day to grow professionally.',
  paragraphThree: 'Feel free to contact me via email at any time',
  resume: 'https://drive.google.com/file/d/1_ZvWGw4oAXj50jlBCxLmKI7bAJS55fHY/view', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'compbook.png',
    title: 'Compbook',
    info:
      'Tailwind components get you up and running in no time. The problem is that they are hard to manage, so I built compbook. Compbook allow you to organize your component library, create templates and use them ease!',
    info2: 'I used React, Tailwind and Firebase in order to create this web application',
    url: 'https://compbook.netlify.app/',
    repo: 'https://github.com/itstaranarora/compbook', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'eventhut.png',
    title: 'Eventhut',
    info:
      'Eventhut is a platform that connects you to events. Users can discover and book slot for their favorite events using this web application.',
    info2:
      'Frontend for this app is build using NextJs and for Backend I have used Strapi (Headless Node.js based CMS). This app also use incremental static regeneration ',
    url: 'https://eventhut.vercel.app/',
    repo: 'https://github.com/itstaranarora/eventhut-next',
  },
  {
    id: nanoid(),
    img: 'docwind.png',
    title: 'Docwind',
    info:
      'DocWind is a collaborative cloud document editing tool that allows you to edit a single document with multiple users in real-time. You can also use the in-build audio call function to call your colleagues and discuss the document in an efficient way.',
    info2: 'This app is build using Preact, Socket.io, and Simple-peer',
    url: 'https://docwind.netlify.app/',
    repo: 'https://github.com/itstaranarora/Docwind-frontend', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'movietrova.png',
    title: 'Movietrova',
    info: 'A prograssive web application to find ratings and parental guide for the newest movie.',
    info2: 'I used React, React Router and TMDB API in order to create this website',
    url: 'https://movietrova.netlify.app/',
    repo: 'https://github.com/itstaranarora/movietrova', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'video-chat.png',
    title: 'Video-chat-v1',
    info:
      'Video-chat-v1 is a video chat app that makes it easy to groups up with people you want to meet',
    info2: 'This app is build using NodeJS, Socket.io, and Peerjs(WebRTC)',
    url: 'https://video-chat-app-v1.herokuapp.com/',
    repo: 'https://github.com/itstaranarora/video-chat-v1/', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'snackstore.png',
    title: 'Snackstore',
    info: 'Snackstore is a online food-ordering single page web application.',
    info2: 'This app is build using React, Context API and Firebase Authentication Service',
    url: 'https://snackstore-react.web.app/',
    repo: 'https://github.com/itstaranarora/snackstore', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'signUpForm.png',
    title: 'Multi-Step Signup Form',
    info:
      'A Multi-step Signup Form with unique username generator build with HTML, CSS and vanilla Javascript(No library or framework used).',
    info2: 'I build this project to practice my Javascript skills',
    url: 'https://itstaranarora.github.io/MultiStep-Signup-Form/',
    repo: 'https://github.com/itstaranarora/MultiStep-Signup-Form', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'covid-19-tracker.png',
    title: 'Covid-19 Tracker',
    info:
      'A web application to track the infected, recovered, and deaths caused by Coronavirus across all over the world.',
    info2:
      'I made this project by following a tutorial from Javascript Mastery(Youtube Channel) and Added my own touch to the UI',
    url: 'https://itstaranarora.github.io/covid19-tracker/',
    repo: 'https://github.com/itstaranarora/covid19-tracker', // if no repo, the button will not show up
  },

  {
    id: nanoid(),
    img: 'Weather.png',
    title: 'Weather PWA',
    info: 'A React Based Prograssive Web Application that shows Weather',
    info2: 'I build this project to learn how to work with APIs.',
    url: 'https://my-weather-pwa.netlify.app/',
    repo: 'https://github.com/itstaranarora/weather-pwa', // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: 'stangerchat.jpg',
    title: 'Strangers Chat',
    info: 'A Firebase based Group Messaging app where strangers can send any text message',
    info2: 'This project is build using React, Firebase and Material UI.',
    url: 'https://stangers-chat.web.app/',
    repo: 'https://github.com/itstaranarora/messenger-clone', // if no repo, the button will not show up
  },

  {
    id: nanoid(),
    img: 'hotorcold.png',
    title: 'Hot or Not Game',
    info:
      'The machine picks a random number between 1 to 100 and keeps it hidden and player need to guess until you can find the hidden secret number.',
    info2: 'This was one of the first project that I build while learning React',
    url: 'https://itstaranarora.github.io/hot-or-cold/',
    repo: 'https://github.com/itstaranarora/hot-or-cold', // if no repo, the button will not show up
  },
];

// CONTACT DATA
export const contactData = {
  cta: 'Would you like to work with me? Awesome!',
  btn: "Let's build together!",
  email: 'itstaranarora@gmail.com',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'twitter',
      url: 'https://twitter.com/itstaranarora',
    },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://linkedin.com/in/taran-arora',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/itstaranarora',
    },
    {
      id: nanoid(),
      name: 'medium',
      url: 'https://itstaranarora.medium.com/',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
